import type { StyleSheet, StyleSheetPut } from "@contract";

type Term = StyleSheetPut["terms"][number];
export interface EditableStyleSheet extends Omit<StyleSheetPut, "conventions" | "terms"> {
  conventions: Array<StyleSheetPut["conventions"][number] & { localId: string }>;
  terms: Array<
    Omit<Term, "forms"> & {
      localId: string;
      forms: Array<Term["forms"][number] & { localId: string }>;
    }
  >;
}
export const editableContent = (sheet: StyleSheet): EditableStyleSheet => ({
  baseVersion: sheet.version,
  book: sheet.content.book,
  conventions: sheet.content.conventions.map((row) => ({ ...row, localId: crypto.randomUUID() })),
  terms: sheet.content.terms.map((term) => ({
    ...term,
    localId: crypto.randomUUID(),
    forms: term.forms.map((form) => ({ ...form, localId: crypto.randomUUID() })),
  })),
});
export const wireStyleSheet = (sheet: EditableStyleSheet): StyleSheetPut => ({
  baseVersion: sheet.baseVersion,
  book: sheet.book,
  conventions: sheet.conventions.map(({ topic, rule }) => ({ topic, rule })),
  terms: sheet.terms.map(({ term, say_as, ipa, note, forms }) => ({
    term,
    say_as,
    ipa,
    note,
    forms: forms.map(({ spelling, say_as, ipa }) => ({ spelling, say_as, ipa })),
  })),
});
